import { ErrorPageContent } from "@/lib/interfaces/globalInterfaces";

export const errorPageContent: ErrorPageContent = {
  en: {
    tryAgain: "Try again",
    pleaseTryAgainLater: "Please try again later",
    somethingWentWrong: "Something Went Wrong",
  },
  zh: {
    tryAgain: "请重试",
    pleaseTryAgainLater: "请稍后再试",
    somethingWentWrong: "出现错误",
  },
  es: {
    tryAgain: "Inténtalo de nuevo",
    pleaseTryAgainLater: "Vuelve a intentarlo más tarde",
    somethingWentWrong: "Se ha producido un error",
  },
  "fr-CA": {
    tryAgain: "Réessayer",
    pleaseTryAgainLater: "Veuillez réessayer ultérieurement",
    somethingWentWrong: "Un problème est survenu.",
  },
};
